<template>
    <div v-show="desks.length > 0" class="bg-white">

        <div id="map" style="height:400px;" class="w-full"></div>

        <div class="flex justify-center">
            <div class="flex mx-4 items-center">
                <div class="w-4 h-4 rounded-full mr-2 bg-green-500"></div>
                0% - 20%
            </div>
            <div class="flex mx-4 items-center">
                <div class="w-4 h-4 rounded-full mr-2 bg-yellow-500"></div>
                20% - 80%
            </div>
            <div class="flex mx-4 items-center">
                <div class="w-4 h-4 rounded-full mr-2 bg-red-500"></div>
                > 80% Auslastung
            </div>
        </div>

        <portal to="modals" v-if="showModal">
            <modal @close="showModal = false">

                <p class="mb-8">
                    Möchtest du Schreibtisch <span class="font-bold">{{ selected.name }}</span> zur Buchung auswählen?
                </p>

                <button-primary @click="confirm">Auswählen</button-primary>

            </modal>
        </portal>

    </div>
</template>

<script>
import L from "leaflet";
import Card from "./UI/Card";
import ButtonPrimary from "./UI/ButtonPrimary";
import Modal from "./Modal";

export default {
    name: "NavigationHeatmap",

    components: {Modal, ButtonPrimary, Card},

    props: {
        items: {
            type: Array,
            default: () => ([]),
        },
        unavailable: {
            type: Array,
            default: () => ([]),
        },
    },

    watch: {
        items() {
            this.init();
        },
    },

    data: () => ({
        selectedId: null,
        map: null,
        showModal: false,
    }),

    computed: {
        selected() {
            if (!this.selectedId) {
                return null;
            }
            return this.items.find(item => item.id === this.selectedId);
        },
        image() {
            if (!this.items[0] || !this.items[0].room) {
                return '';
            }

            return this.items[0].room.map_link;
        },
        desks() {
            return this.items.filter(desk => desk.position);
        },
    },

    mounted() {
        this.init();
    },

    methods: {
        init() {
            if (this.map != null) {
                this.map.remove();
                this.map = null;
            }

            let img = new Image();

            img.onload = () => {
                let minZoom = - Math.ceil( Math.max(img.width + img.height) / 1000 );
                this.map = L.map('map', {
                    crs: L.CRS.Simple,
                    minZoom: minZoom,
                    maxZoom: 2,
                    zoomSnap: 0.1,
                });
                this.createMap(img.width, img.height)
            }

            img.src = this.image;
        },
        createMap(width, height) {
            let bounds = [[0, 0], [height, width]];
            let image = L.imageOverlay(this.image, bounds).addTo(this.map);
            this.map.setMaxBounds(bounds);

            //this.setZoom();
            this.map.fitBounds(bounds);

            this.add();
        },
        confirm() {
            this.$emit('selected', this.selected);
        },
        add() {
            this.items.forEach(item => {
                this.addClickableRectangle(item);
            })
            this.addUnavailable();
        },
        setZoom() {
            //determine desk most left, top, right and bottom value!
            if (this.desks.length === 0) {
                return; // TODO set ZOOM to all of the map!
            }

            let [l, t] = this.desks[0].position.center;
            let [r, b] = this.desks[0].position.center;

            this.desks.forEach(desk => {
                l = Math.min(l, desk.position.center[0]);
                b = Math.min(b, desk.position.center[1]);
                r = Math.max(r, desk.position.center[0]);
                t = Math.max(t, desk.position.center[1]);
            })

            this.map.fitBounds([
                [l, t],
                [r, b]
            ]);
        },
        addUnavailable() {
            this.unavailable.forEach(item => {
                if (!item.position) {
                    return;
                }
                if (item.position.type === 'circle') {
                    L.circle(item.position.center, {color: "red", radius: item.position.radius, weight: 1})
                        .addTo(this.map);

                    return;
                }

                L.rectangle([
                    [item.position.center[0] + item.position.height, item.position.center[1] - item.position.width],
                    [item.position.center[0] - item.position.height, item.position.center[1] + item.position.width],
                ], {color: "red", weight: 1})
                    .addTo(this.map);
            })
        },
        addClickableRectangle(item) {
            if (!item.position) {
                return;
            }

            let layer;

            let color = "#10B981";
            if (item.total > 0.2) {
                color = 'rgba(245, 158, 11, var(--tw-bg-opacity))';
            }
            if (item.total > 0.8) {
                color = 'rgba(239, 68, 68, var(--tw-bg-opacity))';
            }

            if (item.position.type === 'circle') {
                layer = L.circle(item.position.center, {
                    color: color,
                    radius: item.position.radius,
                    weight: 1,
                    id: item.id
                });
            } else {
                layer = L.rectangle([
                    [item.position.center[0] + item.position.height, item.position.center[1] - item.position.width],
                    [item.position.center[0] - item.position.height, item.position.center[1] + item.position.width],
                ], {color: color, weight: 1, id: item.id});
            }

            layer
                .addTo(this.map)
                .on('click', (e) => {
                    this.toggle(e.target.options.id);
                });
        },
        toggle(id) {
            this.selectedId = id;
            this.confirm();
        }

    }
}
</script>

<style scoped>
#map {
    background: white;
}
</style>
